module.exports = __webpack_public_path__ + "media/img/pages/profile/zhaw ger 5-9f078d4162615a700d7ff1e112507468.jpg";